import React, { Component } from 'react';
import Utils from '../../utils.js'
import ReactTooltip from 'react-tooltip'
import Select from 'react-select';


class ProductName extends Component {
    isCreateNewProduct = false;
    missingProductMissingEnv = [];
    constructor(props) {
        super(props);
        this.state = {
            group: [],
            customAdGroup: false,
            project: '',
            prodProxyName: '',
            testProxyName: '',
            pilotProxyName: '',
            singleProxyEnv: "",
            singleProxyEnvError: false,
            singleProductExistsEnvError: false,
            singleProductEnv: "",
            singleProductEnvError: false,
            proxyName: '',
            proxyGroupName: '',
            productOwnerMissingEnv: {},
            productOwnerMissingEnvError: false,
            ownerADMissmatchError: false,
            adGroup: '',
            selectedContainer: 'git',
            buildEnvironmentError: false,
            selectedOption: null,
            groupOwnerGroup: null,
            validADGroupFromGitURL: false,
            projectName: null,
            baseEnvironment: "",
            productGroupNotPresentErr: false,
            singleEnv: "",
            singleEnvError: false,
            multiEnv: [],
            multiEnvError: false,
            productOwnerError: false,
            adGroupOptions: [],
            selectedAdGroup: null,
            isLoadingAdGroups: false,
            productAlreadyExistsError: false,
            existingProductEnvironments: [],
            adGroupMismatchOptions: [],
            productMissingInEnvironments: false,
            missingProductEnvironments: [],
        };
    }

    isValidated = () => {

        if (!this.isCreateNewProduct && this.state.selectedOption === null) {

            return false;
        }

        if (this.state.adGroup === '' && this.props.getStore().adGroup === '') {
            return false;
        }


        if (this.state.productName === '') {
            return false;
        }

        if (this.isCreateNewProduct && this.props.getStore().gitURL === '') {
            return false;
        }

        if (this.isCreateNewProduct && this.state.singleProductExistsEnvError === true) {

            return false;
        }

        if (this.isCreateNewProduct && this.state.productAlreadyExistsError === true) {

            return false;
        }

        if (!this.isCreateNewProduct && this.state.productMissingInEnvironments === true) {

            return false;
        }

        //    if(this.props.getStore().isSubmit === true ) {
        //      	return false;
        //      }


    };

    isValidGitUrl = () => {
        const gitURL = this.props.getStore().gitURL;

        // Return false if URL contains "git@github.com"
        if (gitURL && gitURL.includes("git@github.com")) {
            return false;
        }

        if (Utils.isValidGitUrl(gitURL)) {
            return true;
        } else {
            return false;
        }
    };

    isAdGroupPresent = () => {
        return this.props.getStore().adGroup;
    };

    handleContainerChange = (e) => {
        this.setState({ selectedContainer: e.target.value });
        this.setState({ productAlreadyExistsError: false });

        // Clear productname and adgroup when radio button changes
        this.setState({
            selectedOption: null,
            adGroup: '',
            selectedAdGroup: null,
            project: '',
            proxyGroupName: ''
        });
        this.props.updateStore({
            productName: '',
            adGroup: '',
            project: '',
            proxyGroupName: ''
        });

        if (e.target.value === 'createNewProduct') {
            this.setState({ customAdGroup: false });
            this.isCreateNewProduct = true;
            this.props.updateStore({ isNewProduct: true });
        } else {
            this.setState({ customAdGroup: false });
            this.isCreateNewProduct = false;
            this.props.updateStore({ isNewProduct: false });
        }
    };

    //lambda ensures correct 'this' scope
    onGitUrlChange = async (e) => {
        this.isCreateNewProduct = true;
        this.setState({ singleProductEnvError: false });
        this.setState({ singleProductExistsEnvError: false });
        this.setState({ productOwnerMissingEnvError: false });
        this.setState({ ownerADMissmatchError: false });
        this.setState({ productAlreadyExistsError: false });
        this.props.updateStore({ isSubmit: false });

        //this.props.updateStore({ adGroup: '' });
        //this.props.updateStore({ productName: '' });

        this.isValidGitUrl();

        if (!e.target.value) {
            this.props.updateStore({
                gitURL: ''
            });
            this.setState({ gitURL: '' });
        } else {
            this.props.updateStore({
                gitURL: e.target.value
            });
            this.setState({ gitURL: e.target.value });
            let project = Utils.getProjectNameFromGitUrl(e.target.value);

            let data = this.props.getStore();
            const proxyGroupName = Utils.constructProductComponentName(data.subBU, project);
            this.setState({ proxyGroupName: proxyGroupName });
            this.props.updateStore({ productName: proxyGroupName });

            const proxyName = Utils.constructProxyComponentName(data.subBU, data.virtualPath);
            this.setState({ proxyName: proxyName });

            // Validate if product already exists in the selected environments
            await this.validateProductExists(proxyGroupName);
            if (!this.state.productAlreadyExistsError) {
                this.setState({ customAdGroup: true });
            }

            if (!this.isValidGitUrl() === true) {
                this.setState({ customAdGroup: false });
            }
            // Don't validate proxy exists for Create New Product scenario
            // await Utils.validateProxyExistsWithProduct(this, proxyName, proxyGroupName, true);

        }
    };

    onProductChange = async (selectedOption) => {

        this.setState({ customAdGroup: false, singleProductEnvError: false, singleProductExistsEnvError: false });
        this.setState({ productOwnerMissingEnvError: false });
        this.setState({ ownerADMissmatchError: false });
        this.setState({ adGroupMismatchOptions: [] });
        this.setState({ productMissingInEnvironments: false, missingProductEnvironments: [] });
        this.props.updateStore({ isSubmit: false });
        this.props.updateStore({ productName: selectedOption.value });
        await this.setState({ selectedOption: selectedOption.value });
        this.props.updateStore({ adGroup: '' });
        this.props.updateStore({ productName: '' });
        let data = this.props.getStore();
        const proxyGroupName = selectedOption.value;
        this.setState({ proxyGroupName: proxyGroupName });
        this.props.updateStore({ productName: proxyGroupName });
        const proxyName = Utils.constructProxyComponentName(data.subBU, data.virtualPath);
        this.setState({ proxyName: proxyName });

        // Validate if the selected product exists in all selected environments
        await this.validateSelectedProductInAllEnvironments(proxyGroupName);

        //await Utils.validateIfProxyAlreadyExists(this, proxyName, proxyGroupName);
        await Utils.validateProxyExistsWithProduct(this, proxyName, proxyGroupName, false);

    }



    // Method to handle AD Group selection
    onAdGroupChange = async (selectedOption) => {
        this.setState({ selectedAdGroup: selectedOption });
        await this.props.updateStore({
            adGroup: selectedOption ? selectedOption.value : ''
        });
        this.setState({ adGroup: selectedOption ? selectedOption.value : '' });
        this.setState({ productOwnerMissingEnvError: false });
    };

    updateAdGroup = async (e) => {
        const adGroupValue = e.target.value;
        await this.props.updateStore({
            adGroup: adGroupValue
        });
        await this.setState({ adGroup: adGroupValue });
        this.setState({ productOwnerMissingEnvError: false });
    };

    // Method to validate if product already exists in any environment
    validateProductExists = async (productName) => {
        if (!productName) return;

        let data = this.props.getStore();
        const selectedEnvs = data.buildEnvironment ? data.buildEnvironment.split(",") : [];

        if (selectedEnvs.length === 0) {
            // If no environment is selected, check all environments
            selectedEnvs.push("TEST", "PILOT", "PRODUCTION");
        }

        const existingEnvironments = [];

        // Check each environment
        for (const env of selectedEnvs) {
            try {
                const apiName = 'Get Apigee Info API';

                // Map environment to Lambda API paths
                const envPathMap = {
                    "PRODUCTION": "/prod/products",
                    "PILOT": "/pilot/products",
                    "TEST": "/test/products"
                };

                const path = envPathMap[env];
                if (!path) continue;

                const products = await Utils.fetchLambdaApis(apiName, path, null);

                // Check if the product exists in this environment
                const productExists = products.some(product =>
                    product === productName ||
                    (typeof product === 'object' && product.name === productName)
                );

                if (productExists) {
                    existingEnvironments.push(env);
                }
            } catch (error) {
                console.error(`Error checking product existence in ${env}:`, error);
            }
        }

        // Update state based on findings
        if (existingEnvironments.length > 0) {
            this.setState({
                productAlreadyExistsError: true,
                existingProductEnvironments: existingEnvironments
            });
        } else {
            this.setState({
                productAlreadyExistsError: false,
                existingProductEnvironments: []
            });
        }
    };

    // Method to validate if selected product exists in all selected environments
    validateSelectedProductInAllEnvironments = async (productName) => {
        if (!productName) return;

        let data = this.props.getStore();
        const selectedEnvs = data.buildEnvironment ? data.buildEnvironment.split(",") : [];

        if (selectedEnvs.length <= 1) {
            // If only one environment is selected, no need to validate across multiple environments
            return;
        }

        const missingEnvironments = [];

        // Check each selected environment
        for (const env of selectedEnvs) {
            try {
                const apiName = 'Get Apigee Info API';

                // Map environment to Lambda API paths
                const envPathMap = {
                    "PRODUCTION": "/prod/products",
                    "PILOT": "/pilot/products",
                    "TEST": "/test/products"
                };

                const path = envPathMap[env];
                if (!path) continue;

                const products = await Utils.fetchLambdaApis(apiName, path, null);

                // Check if the product exists in this environment
                const productExists = products.some(product =>
                    product === productName ||
                    (typeof product === 'object' && product.name === productName)
                );

                if (!productExists) {
                    missingEnvironments.push(env);
                }
            } catch (error) {
                console.error(`Error checking product existence in ${env}:`, error);
                // If API call fails, consider it as missing
                missingEnvironments.push(env);
            }
        }

        // Update state based on findings
        if (missingEnvironments.length > 0) {
            this.setState({
                productMissingInEnvironments: true,
                missingProductEnvironments: missingEnvironments
            });
        } else {
            this.setState({
                productMissingInEnvironments: false,
                missingProductEnvironments: []
            });
        }
    };

    componentDidMount() {
        //Resetting previous selection on load
        this.props.updateStore({ gitURL: "", adGroup: "", productName: "" });
        this.setState({ productOwnerMissingEnvError: false });
        // Fetch AD Groups from API
        Utils.fetchAdGroups(this);

        let selectedEnvs = [];

        if (null !== this.props.getStore().buildEnvironment
            && this.props.getStore().buildEnvironment.length > 0) {



            selectedEnvs = this.props.getStore().buildEnvironment.split(",").sort((a, b) => {
                const order = ["TEST", "PILOT", "PRODUCTION"];
                return order.indexOf(a) - order.indexOf(b);
            });

            const apiName = 'Get Apigee Info API';
            let apiPath = '';

            if (null !== selectedEnvs && selectedEnvs.length === 1) {

                if (selectedEnvs.includes("PRODUCTION")) {
                    apiPath = '/prod/products';
                    this.setState({ baseEnvironment: "PRODUCTION" });

                } else if (selectedEnvs.includes("PILOT")) {
                    apiPath = '/pilot/products';
                    this.setState({ baseEnvironment: "PILOT" });

                } else {
                    apiPath = '/test/products';
                    this.setState({ baseEnvironment: "TEST" });

                }
            } else if (null !== selectedEnvs && selectedEnvs.length > 1) {
                if (selectedEnvs.includes("PRODUCTION")) {
                    apiPath = '/prod/products';
                    this.setState({ baseEnvironment: "PRODUCTION" });

                } else if (selectedEnvs.includes("PILOT")) {
                    apiPath = '/pilot/products';
                    this.setState({ baseEnvironment: "PILOT" });

                } else {
                    apiPath = '/test/products';
                    this.setState({ baseEnvironment: "TEST" });

                }
            }

            Utils.fetchLambdaApis(apiName, apiPath, null)
                .then(json => {
                    this.setState({
                        groups: json
                            .filter(e => e.match(/^(AR_)?RIS-/))
                            .sort()
                            .map(e => {
                                return {
                                    label: e,
                                    value: e
                                }
                            })
                    });
                })
                .catch(error => {
                    console.error('Error fetching products:', error);
                });
            //}
        }

    }


    render() {
        let data = this.props.getStore();
        return (
            <div>
                <div className="container">
                    <br />
                    <div className="row">
                        <div className="col-md-8">
                            {/* Radio buttons for container selection */}
                            <div style={{ marginBottom: '20px' }}>
                                <label>
                                    <input
                                        type="radio"
                                        name="containerSelect"
                                        value="createNewProduct"
                                        checked={this.state.selectedContainer === 'createNewProduct'}
                                        onChange={this.handleContainerChange}
                                        style={{ marginRight: '5px' }}
                                    />
                                    Create a New Product
                                </label>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <label>
                                    <input
                                        type="radio"
                                        name="containerSelect"
                                        value="chooseFromExistingProducts"
                                        checked={this.state.selectedContainer === 'chooseFromExistingProducts'}
                                        onChange={this.handleContainerChange}
                                        style={{ marginRight: '5px' }}
                                    />
                                    Choose from existing products
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Show Git Clone URL container if selected */}
                {this.state.selectedContainer === 'createNewProduct' && (
                    <div className="container">
                        <br />
                        <div className="row">
                            <div className="col-md-8">
                                <label htmlFor="gitURL">
                                    <span>Git Clone URL </span>
                                    <span className="tooltipCustomReact" data-tip="React-tooltip">
                                        ?
                                    </span>
                                    <ReactTooltip effect="solid" place="right">
                                        <span>
                                            Git Clone URL of the <i>service/endpoint</i>. <br />
                                            Used to identify the <i>proxy group</i> with which the <i>proxy</i> will associate, as well as the <b>team</b> that owns the <i>proxy</i>.
                                        </span>
                                    </ReactTooltip>
                                </label>
                                <input
                                    className="form-control"
                                    id="gitURL"
                                    name="gitURL"
                                    value={data.gitURL}
                                    onChange={this.onGitUrlChange}
                                    placeholder="https://github.com/principalris-emu/maven-archetype-rest-template.git"
                                />
                                {!this.isValidGitUrl() && (
                                    <p id="gitUrlWarning" className="alert alert-danger util-margin-top-10">
                                        Must be a valid .git https url to proceed.
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <span>Proxy Group Name: </span>
                                <span>{Utils.constructComponentName(data.subBU, data.gitURL)}</span>
                            </div>
                            <br />
                        </div>


                        {this.state.customAdGroup && !this.state.productAlreadyExistsError && (

                            <div>
                                <hr />
                                <ADGroupCreateProduct
                                    selectedAdGroup={this.state.selectedAdGroup}
                                    onAdGroupChange={this.onAdGroupChange}
                                    adGroupOptions={this.state.adGroupOptions}
                                    isLoading={this.state.isLoadingAdGroups}
                                />
                            </div>)}
                        <hr />
                        {this.state.productAlreadyExistsError && (
                            <p className="alert alert-danger util-margin-top-10">
                                The Product named '{this.state.proxyGroupName}' already exists in the following environment(s): ({this.state.existingProductEnvironments.join(', ')}). Please provide a different Git URL or contact API Platform Engineering Team.
                            </p>
                        )}
                        {this.state.singleProxyEnvError && (
                            <p className="alert alert-danger util-margin-top-10">
                                APIProxy named '{this.state.proxyName}' is already present in the environment ({this.state.singleProxyEnv}). Please select an appropriate option from the "Build Environment" and "Routing" steps and try again.
                            </p>
                        )}
                        {this.state.singleProductExistsEnvError && (
                            <p className="alert alert-danger util-margin-top-10">
                                The Product named '{this.state.proxyGroupName}' is already present in the environment ({this.state.singleProxyEnv}). Please provide a new Product through the Git URL and try again.
                            </p>
                        )}
                        {this.state.singleProductEnvError && (
                            <p className="alert alert-danger util-margin-top-10">
                                APIProxy named '{this.state.proxyName}' is already associated with product '{this.state.proxyGroupName}' in the environment ({this.state.singleProductEnv}). Please select an appropriate option from the "Build Environment" and and "Routing" steps and try again.
                            </p>
                        )}

                    </div>
                )}

                {/* Show Product Name container if selected */}
                {this.state.selectedContainer === 'chooseFromExistingProducts' && (
                    <div className="container">
                        <br />
                        <div className="row">
                            <div className="col-md-8">
                                <h4>Product Name</h4>
                                <label htmlFor="productName"></label>
                                <p>The name of the proxy group name. (Filtered from {this.state.baseEnvironment})</p>
                                <Select
                                    id="productName"
                                    value={this.state.selectedOption}
                                    onChange={this.onProductChange}
                                    options={this.state.groups}
                                />
                                <br />
                                <div className="row">
                                    <div className="col-md-6">
                                        <span>Proxy Group Name: </span>
                                        <span>{this.state.selectedOption}</span>
                                    </div>
                                    <br />
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <span>AD Group: </span>
                                        <span>{this.state.adGroup}</span>
                                    </div>
                                    <br />
                                </div>
                                <hr />

                                {this.state.customAdGroup && !this.state.productMissingInEnvironments && (<div>
                                    <ADGroupExistingProduct
                                        adGroup={data.adGroup}
                                        updateAdGroup={this.updateAdGroup}
                                        adGroupMismatchOptions={this.state.adGroupMismatchOptions}
                                    />
                                </div>)}



                                {this.state.singleProxyEnvError && (
                                    <p className="alert alert-danger util-margin-top-10">
                                        APIProxy named '{this.state.proxyName}' is already present in the environment ({this.state.singleProxyEnv}). Please select an appropriate option from the "Build Environment" step and try again.
                                    </p>
                                )}
                                {this.state.productOwnerMissingEnvError && (
                                    <p className="alert alert-danger util-margin-top-10">
                                        Product Owner AD Group is not associated with product '{this.state.proxyGroupName}' in the environment(s) ({this.state.productOwnerMissingEnv}). Please provide a valid Security Enabled AD group.
                                    </p>
                                )}
                                {this.state.singleProductEnvError && (
                                    <p className="alert alert-danger util-margin-top-10">
                                        APIProxy named '{this.state.proxyName}' is already associated with product '{this.state.proxyGroupName}' in the environment ({this.state.singleProductEnv}). Please select an appropriate option from the "Build Environment" step and try again.
                                    </p>
                                )}
                                {this.state.productMissingInEnvironments && (
                                    <p className="alert alert-danger util-margin-top-10">
                                        The selected product '{this.state.proxyGroupName}' is not available in the following environment(s): ({this.state.missingProductEnvironments.join(', ')}). Please make sure product exists in all the selected environments or contact API Platform Engineering Team.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const ADGroupCreateProduct = (props) => {
    return <div>
        <div className="row">
            <div className="col-md-8">
                <label htmlFor="adGroup">AD Group</label>
                <p>This is for assigning group ownership for the newly created product</p>
                <Select
                    id="adGroup"
                    name="adGroup"
                    value={props.selectedAdGroup}
                    onChange={props.onAdGroupChange}
                    options={props.adGroupOptions}
                    placeholder="Select an AD Group..."
                    isSearchable={true}
                    isLoading={props.isLoading}
                />
            </div>
        </div>
    </div>
}


const ADGroupExistingProduct = (props) => {
    // Check if adGroupMismatchOptions is null, undefined, or empty array
    const shouldShowDropdown = props.adGroupMismatchOptions &&
        Array.isArray(props.adGroupMismatchOptions) &&
        props.adGroupMismatchOptions.length > 0;

    const dropdownOptions = shouldShowDropdown
        ? props.adGroupMismatchOptions.map(option => ({
            value: option,
            label: option
        }))
        : [];

    const handleDropdownChange = (selectedOption) => {
        const mockEvent = {
            target: {
                value: selectedOption ? selectedOption.value : ''
            }
        };
        props.updateAdGroup(mockEvent);
    };

    return <div>
        <div className="row">
            <div className="col-md-8">
                <label htmlFor="adGroup">AD Group</label>
                {shouldShowDropdown ? (
                    <div>
                        <p>Select an already available owner AD group for this product.</p>
                        <Select
                            id="adGroup"
                            name="adGroup"
                            value={dropdownOptions.find(option => option.value === props.adGroup) || null}
                            onChange={handleDropdownChange}
                            options={dropdownOptions}
                            placeholder="Select an AD Group..."
                            isSearchable={true}
                        />
                    </div>
                ) : (
                    <div>
                        <p>There is no owner AD group associated with the selected product, please provide a valid security AD group for sending an approval email.</p>
                        <input
                            className="form-control"
                            id="adGroup"
                            name="adGroup"
                            value={props.adGroup}
                            onChange={props.updateAdGroup}
                        />
                    </div>
                )}
            </div>
        </div>
    </div>
}

export default ProductName;
